import { render, staticRenderFns } from "./spec__list.vue?vue&type=template&id=2c003b7b"
import script from "./spec__list.vue?vue&type=script&lang=js"
export * from "./spec__list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports